import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fuse-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  @Input() text = 'Not found';

  constructor() { }

  ngOnInit(): void {
  }

}
